// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShipETAs {
  width: 100%;
  padding: 20px 30px;
}

  .ShipETAs-spinner {
    position: absolute;
    right: 45%;
    bottom: 50%;
    width: 100px;
    height: 100px;
  }

  .ShipETAs__title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 30px;
  }

  .ShipETAs__table {
    width: 100%;
    margin-bottom: 25px;
  }

  .ShipETAs__table th {
      text-align: left;
    }

  .ShipETAs__table td {
      padding: 10px 0;
    }

  .ShipETAs__table td:nth-child(1) {
      width: 20%;
    }

  .ShipETAs__table td:nth-child(2) {
      width: 60%;
    }

  .ShipETAs__table tbody > tr {
      cursor: pointer;
      border-bottom: 1px solid gray;
    }

  .ShipETAs__table th {
      max-width: 150px;
    }

  .ShipETAs__table th:nth-child(2) {
      min-width: 120px;
    }

  .ShipETAs .right-sidebar-navigation__content-open {
    background: white;
    box-shadow: 0 2px 2px 0 #bbbcbd;
    padding: 20px;
    margin-bottom: 60px;
    height: 100vh;
    overflow-y: scroll;
    width: 500px;
    position: fixed;
    top: 55px;
  }

  .ShipETAs .sidebar-content {
    display: flex;
    flex-direction: column;
  }

  .ShipETAs .sidebar-content-section {
      margin-bottom: 30px;
    }

  .ShipETAs .sidebar-content-section_title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 5px;
    }

  .ShipETAs .sidebar-content-section_content {
      font-size: 16px;
    }

  .ShipETAs .sidebar-content-date_input {
      margin-top: 10px;
      width: 125px;
    }

  .ShipETAs .sidebar-content-btn {
      width: 125px;
      margin-bottom: 20px;
    }

  .ShipETAs__selected {
    background-color: lightgreen;
  }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/Admin/features/ShipETAs/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AA8FpB;;EA5FE;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EA8BrB;;EA5BE;MACE,gBAAgB;IAClB;;EAEA;MACE,eAAe;IACjB;;EAEA;MACE,UAAU;IACZ;;EAEA;MACE,UAAU;IACZ;;EAEA;MACE,eAAe;MACf,6BAA6B;IAC/B;;EAEA;MACE,gBAAgB;IAClB;;EAEA;MACE,gBAAgB;IAClB;;EAGF;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;EAyBxB;;EAvBE;MACE,mBAAmB;IACrB;;EAEA;MACE,eAAe;MACf,gBAAgB;MAChB,kBAAkB;IACpB;;EAEA;MACE,eAAe;IACjB;;EAEA;MACE,gBAAgB;MAChB,YAAY;IACd;;EAEA;MACE,YAAY;MACZ,mBAAmB;IACrB;;EAGF;IACE,4BAA4B;EAC9B","sourcesContent":[".ShipETAs {\n  width: 100%;\n  padding: 20px 30px;\n\n  &-spinner {\n    position: absolute;\n    right: 45%;\n    bottom: 50%;\n    width: 100px;\n    height: 100px;\n  }\n\n  &__title {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 30px;\n  }\n\n  &__table {\n    width: 100%;\n    margin-bottom: 25px;\n\n    th {\n      text-align: left;\n    }\n\n    td {\n      padding: 10px 0;\n    }\n\n    td:nth-child(1) {\n      width: 20%;\n    }\n\n    td:nth-child(2) {\n      width: 60%;\n    }\n\n    tbody > tr {\n      cursor: pointer;\n      border-bottom: 1px solid gray;\n    }\n\n    th {\n      max-width: 150px;\n    }\n\n    th:nth-child(2) {\n      min-width: 120px;\n    }\n  }\n\n  .right-sidebar-navigation__content-open {\n    background: white;\n    box-shadow: 0 2px 2px 0 #bbbcbd;\n    padding: 20px;\n    margin-bottom: 60px;\n    height: 100vh;\n    overflow-y: scroll;\n    width: 500px;\n    position: fixed;\n    top: 55px;\n  }\n\n  .sidebar-content {\n    display: flex;\n    flex-direction: column;\n\n    &-section {\n      margin-bottom: 30px;\n    }\n\n    &-section_title {\n      font-size: 18px;\n      font-weight: 600;\n      margin-bottom: 5px;\n    }\n\n    &-section_content {\n      font-size: 16px;\n    }\n\n    &-date_input {\n      margin-top: 10px;\n      width: 125px;\n    }\n\n    &-btn {\n      width: 125px;\n      margin-bottom: 20px;\n    }\n  }\n\n  &__selected {\n    background-color: lightgreen;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
